import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import AppWebsite from "@/AppWebsite";

const AppComponent = process.env.REACT_APP_MODE === 'website' ? AppWebsite : App;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <AppComponent />
    </HelmetProvider>
  </React.StrictMode>,
);
